import React, { useState } from "react";

import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import Select from "react-select";

const MultipleSelect = (props) => {
 
 
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={true}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 15 }}>
          <Select
            closeMenuOnSelect={true}
            isMulti
            placeholder="Status"
            onChange={(data) => {
              props.setStatus(data);
              // setStatusLength((data && data.length) || "");
              props.setFilterLength(prevState => ({
                ...prevState,
                statusLength: ((data && data.length) || "")
            }));
            }}
            options={props.options}
            value={props.status}
          />
        </div>
        <div style={{ marginBottom: 15 }}>
          <Select
            closeMenuOnSelect={true}
            isMulti
            placeholder="Type"
            onChange={(data) => {
              console.log("Selected Type", data);
              props.setType(data);
              // setTypeLength((data && data.length) || "");
              props.setFilterLength(prevState => ({
                ...prevState,
               typeLength: ((data && data.length) || "")
            }));
            }}
            options={props.options1}
            value={props.type}
          />
        </div>
        <div style={{ marginBottom: 15 }}>
          <Select
            closeMenuOnSelect={true}
            isMulti
            placeholder="Country"
            onChange={(data) => {
              props.setCountry(data);
              // setCountryLength((data && data.length) || "");
              props.setFilterLength(prevState => ({
                ...prevState,
            countryLength: ((data && data.length) || "")
            }));
            }}
            options={props.options2}
            value={props.country}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          color="primary"
          onClick={() => {
            let req = {};
            req.searchType = props.type;
            req.searchCountry = props.country;
            req.searchStatus = props.status;
            req.typeLength = props.filterLength.typeLength;
            req.countryLength =  props.filterLength.countryLength;
            req.statusLength =  props.filterLength.statusLength;
            let temp =
              ( props.filterLength.typeLength || 0 )+
              ( props.filterLength.countryLength || 0) +
              ( props.filterLength.statusLength || 0);
              console.log("noOfFiltersSelected1",temp)
            props.setNoOfFiltersSelected(temp);
            props.saveButtonClicked(req);
            temp=0;
          }}
        >
          Save{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MultipleSelect;
